import React, { useState } from "react";
import { SetPasswordFormStyled } from "./styled";
import { useForm, Controller } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import Countdown from "react-countdown";
import { useTranslation } from "react-i18next";
import { Inputs, Buttons, Icons } from "components";

// const passwordRegex =
//   /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^])[a-zA-Z\d!@#$%^]{8,}$/;

const schema = yup.object().shape({
  otp: yup.string().required("กรุณากรอกรหัส OTP"),
  password: yup
    .string()
    .required("กรุณากรอกรหัสผ่าน"),
    // .matches(
    //   passwordRegex,
    //   "รหัสผ่านต้องมีอย่างน้อย 8 ตัว ประกอบด้วย ตัวพิมพ์ใหญ่ ตัวพิมพ์เล็ก ตัวเลข และอักขระพิเศษ (!@#$%^)"
    // ),
  confirm_password: yup
    .string()
    .required("กรุณายืนยันรหัสผ่าน")
    .oneOf([yup.ref("password")], "รหัสผ่านไม่ตรงกัน"),
});

const SetPasswordForm = ({ email, authProviders, onSubmit, onResendOTP }) => {
  const { t } = useTranslation(["common", "form"]);
  const [resendDisabled, setResendDisabled] = useState(true);

  const {
    control,
    handleSubmit,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(schema),
  });

  const handleResend = () => {
    setResendDisabled(true);
    onResendOTP && onResendOTP();
  };

  const providersText = (authProviders || []).join(", ");

  return (
    <SetPasswordFormStyled>
      <form onSubmit={handleSubmit(onSubmit)}>
        <div className="login_header">ตั้งรหัสผ่าน</div>
        <div className="sub_title">
          {providersText
            ? `คุณเคยสมัครผ่าน ${providersText} กรุณาตั้งรหัสผ่านเพื่อเข้าสู่ระบบด้วยอีเมล`
            : `กรุณาตั้งรหัสผ่านสำหรับ ${email}`}
        </div>
        <div className="sub_title">
          รหัส OTP ถูกส่งไปที่ {email}
        </div>

        <div className="otp_row">
          <div className="otp_input_col">
            <Controller
              control={control}
              render={({ field }) => (
                <Inputs.TextField
                  {...field}
                  placeholder={t("OTP code", { ns: "common" })}
                  errors={errors.otp?.message}
                />
              )}
              name="otp"
              defaultValue=""
            />
          </div>
          <div className="otp_btn_col">
            <Buttons.BgIconPrefix
              icon={<Icons.Resend />}
              label={t("Resend", { ns: "common" })}
              disabled={resendDisabled}
              onClick={handleResend}
            />
          </div>
        </div>
        <div className="otp_detail">
          {resendDisabled && (
            <Countdown
              date={Date.now() + 60000 * 5}
              renderer={({ minutes, seconds }) => (
                <div>
                  0{minutes}:{seconds < 10 ? `0${seconds}` : seconds}
                </div>
              )}
              onComplete={() => setResendDisabled(false)}
            />
          )}
          {t("The OTP code will be sent within 5 minutes", { ns: "form" })}
        </div>

        <div className="input_wrap">
          <Controller
            control={control}
            render={({ field }) => (
              <Inputs.Password
                theme_standard2
                label="รหัสผ่านใหม่"
                placeholder="********"
                {...field}
                errors={errors.password?.message}
              />
            )}
            name="password"
            defaultValue=""
          />
        </div>
        {/* <div className="password_hint">
          รหัสผ่านต้องมีอย่างน้อย 8 ตัว ประกอบด้วย ตัวพิมพ์ใหญ่ ตัวพิมพ์เล็ก
          ตัวเลข และอักขระพิเศษ (!@#$%^)
        </div> */}
        <div className="input_wrap">
          <Controller
            control={control}
            render={({ field }) => (
              <Inputs.Password
                theme_standard2
                label="ยืนยันรหัสผ่าน"
                placeholder="********"
                {...field}
                errors={errors.confirm_password?.message}
              />
            )}
            name="confirm_password"
            defaultValue=""
          />
        </div>

        <Buttons.BgStandard type="submit" label="ตั้งรหัสผ่าน" />
      </form>
    </SetPasswordFormStyled>
  );
};

SetPasswordForm.propTypes = {};

export default SetPasswordForm;
